import {prepareFilter} from '../helpers/filter';
import {getProducts} from '../api/parameters';
import {getContacts} from '../api/locator';

export default {
    fetchContactProcess: ({commit}, status) => commit('fetchContactProcess', status),
    fetchContacts({commit, state, dispatch}) {
        const {filter, selectedTab} = state;
        dispatch('fetchContactProcess', true);
        return getContacts(prepareFilter(filter, selectedTab), state.locatorType)
            .then((data) => {
                commit('setContacts', data);
                dispatch('fetchContactProcess', false);
            }).catch(() => {
                commit('setContacts', []);
                dispatch('fetchContactProcess', false);
            });
    },
    fetchProducts: ({commit}) => getProducts()
        .then((data) => commit('setProducts', data)),
    setCoords: ({commit}, coords) => commit('setCoords', coords),
    setLocatorType: ({commit}, type) => commit('setLocatorType', type),
    setTypes: ({commit}, types) => commit('setTypes', types),
    setProductsType: ({commit}, products) => commit('setProductsType', products),
    setSearch: ({commit}, search) => commit('setSearch', search),
    setMapCenter: ({commit}, positions) => commit('setMapCenter', positions),
    setMapZoom: ({commit}, zoom) => commit('setMapZoom', zoom)
}



// WEBPACK FOOTER //
// ./src/components/locator/actions/index.js